import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { InputNumber } from 'antd';
import { errorProps } from './props';

// This must be a class component because input number is often used
// in fielddecorators. FieldDecorators add a ref property and
// functional components don't support the ref property.
// https://github.com/facebook/react/issues/10831
// eslint-disable-next-line
class CustomInputNumber extends Component {
  render() {
    const { className, ...rest } = this.props;
    return <InputNumber className={className} {...rest} />;
  }
}

CustomInputNumber.propTypes = {
  className: PropTypes.string.isRequired,
};

export default styled(CustomInputNumber)`
  color: ${p => p.theme.colors.text};
  ${errorProps};
`;
